/**
 * ProductStickyAtcDesktop is a custom HTMLElement that provides a sticky "Add to Cart" (ATC) functionality for desktop views.
 * This element listens to the visual state of a product form and reveals or hides itself based on the visibility of that form.
 */
class ProductStickyAtcDesktop extends window.HTMLElement {
  constructor() {
    super()
    this.shown = false
    // Used to prevent the sticky ATC from showing immediately on page load
    this.hasCompletedFirstPass = false
    this.productId = this.dataset.productId

    // Bind the event listener method to the current instance for proper removal later
    this.boundListenToVisibility = this.listenToVisibility.bind(this)
  }

  /**
   * Reveals the sticky "Add to Cart" button by adding a 'visible' class.
   */
  reveal() {
    this.shown = true
    this.classList.add('visible')
  }

  /**
   * Hides the sticky "Add to Cart" button by removing the 'visible' class.
   */
  hide() {
    this.hasCompletedFirstPass = true
    this.shown = false
    this.classList.remove('visible')
  }

  /**
   * Listens to the visibility event of the product form and reveals/hides the sticky button accordingly.
   * @param {Event} e - The event object containing details about the product form's visual state.
   */
  listenToVisibility(e) {
    if (e.detail.id === this.productId) {
      // Reveal the sticky ATC button only when the product form is not visible
      e.detail.visible ? this.hide() : this.reveal()
    }
  }

  connectedCallback() {
    // Attach the event listener for 'product-form:visual-state' events
    document.addEventListener(
      'product-form:visual-state',
      this.boundListenToVisibility
    )
  }

  disconnectedCallback() {
    // Detach the event listener when the element is removed from the DOM to prevent potential memory leaks
    document.removeEventListener(
      'product-form:visual-state',
      this.boundListenToVisibility
    )
  }
}

// Register the custom element 'product-sticky-atc-desktop'
window.customElements.define(
  'product-sticky-atc-desktop',
  ProductStickyAtcDesktop
)

export default ProductStickyAtcDesktop
